import React, { useEffect, useState } from "react";
import fronte from "../assets/comparti/fronte.svg";
import retro from "../assets/comparti/retro.svg";
import fronteCingoloScapolare from "../assets/comparti/fronteCingoloScapolare.svg";
import retroCingoloScapolare from "../assets/comparti/retroCingoloScapolare.svg";
import fronteTronco from "../assets/comparti/fronteTronco.svg";
import retroTronco from "../assets/comparti/retroTronco.svg";
import fronteCingoloPelvico from "../assets/comparti/fronteCingoloPelvico.svg";
import retroCingoloPelvico from "../assets/comparti/retroCingoloPelvico.svg";
import fronteCompleto from "../assets/comparti/fronteCompleto.svg";
import retroCompleto from "../assets/comparti/retroCompleto.svg";

import { Esercizio } from "../interfaces/Esercizio";

interface CompartiMuscolariProps {
    title: string;
    value: string;
    field: keyof Esercizio;
    onChange: <K extends keyof Esercizio>(key: K, value: Esercizio[K]) => void;
    edit: boolean
}

export const comparti = [
    { value: "ShoulderGirdle", label: "Cingolo scapolare", fronte: fronteCingoloScapolare, retro: retroCingoloScapolare },
    { value: "Trunk", label: "Tronco", fronte: fronteTronco, retro: retroTronco },
    { value: "PelvicGirdle", label: "Cingolo pelvico", fronte: fronteCingoloPelvico, retro: retroCingoloPelvico },
    { value: "FullBody", label: "Completo", fronte: fronteCompleto, retro: retroCompleto },
];

const CompartiMuscolari: React.FC<CompartiMuscolariProps> = ({ title, value, field, onChange, edit }) => {
    const [selectedComparto, setSelectedComparto] = useState<string | null>(value);
    const [selectedImages, setSelectedImages] = useState<{ fronte: string; retro: string }>({ fronte, retro });

    useEffect(() => {
        setSelectedComparto(value);
        const compartoSelezionato = comparti.find(c => c.value === value);
        if (compartoSelezionato) {
            setSelectedImages({ fronte: compartoSelezionato.fronte, retro: compartoSelezionato.retro });
        } else {
            setSelectedImages({ fronte, retro });
        }
    }, [value]);

    const handleSelection = (comparto: { value: string; label: string; fronte: string; retro: string }) => {
        setSelectedComparto(comparto.value);
        setSelectedImages({ fronte: comparto.fronte, retro: comparto.retro });
        onChange(field, comparto.value);
    };

    return (
        <div>
            <h5 className="font-semibold mb-3">{title}</h5>
            <div className="row align-items-center">
                <div className="col-3 ">
                    <ul className="list-unstyled">
                        {comparti.map((comparto) => (
                            <li key={comparto.value} className="mb-2">
                                <button
                                    className={`btn ${selectedComparto === comparto.value ? "btn-dark" : "btn-light"} rounded-5 w-100`}
                                    onClick={() => handleSelection(comparto)}
                                >
                                    {comparto.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="col d-flex justify-content-center align-items-center">
                    <img src={selectedImages.fronte} alt="fronte" className="img-fluid mx-2" style={{ maxWidth: "45%" }} />
                    <img src={selectedImages.retro} alt="retro" className="img-fluid mx-2" style={{ maxWidth: "45%" }} />
                </div>
            </div>

        </div>
    );
};

export default CompartiMuscolari;

